const base = require('moment');

class MomentBusinessDays {
  constructor(locale) {
    // this.moment = require('moment');
    this.moment = base;
    this.momentInstance = this.moment();
    this.locale = locale;
  }

  isHoliday(incomingDay) {
    const locale = this.locale;
    if (locale._holidays) {
      if (locale._holidays.indexOf(incomingDay.format(locale._holidayFormat)) >= 0) {
        return true;
      }
    }
    return false;
  }

  isBusinessDay(incomingDay) {
    const locale = this.locale;
    const defaultWorkingWeekdays = [1, 2, 3, 4, 5];
    const workingWeekdays = locale._workingWeekdays || defaultWorkingWeekdays;
    if (this.isHoliday(incomingDay)) {
      return false;
    }
    if (workingWeekdays.indexOf(incomingDay.day()) >= 0) {
      return true;
    }
    return false;
  }

  prevBusinessDay(incomingDay) {
    const locale = this.locale;
    let loop = 1;
    const defaultPrevBusinessDayLimit = 7;
    const limit = locale._prevBusinessDayLimit || defaultPrevBusinessDayLimit;
    let previousDay = incomingDay;
    while (loop < limit) {
      previousDay = incomingDay.subtract(1, 'd');
      if (this.isBusinessDay(previousDay)) {
        break;
      }
      loop += 1;
    }
    return previousDay;
  }

  nextBusinessDay(incomingDay) {
    const locale = this.locale;
    let loop = 1;
    const defaultNextBusinessDayLimit = 7;
    const limit = locale._nextBusinessDayLimit || defaultNextBusinessDayLimit;
    let nextDay = incomingDay;
    while (loop < limit) {
      nextDay = incomingDay.add(1, 'd');
      if (this.isBusinessDay(nextDay)) {
        break;
      }
      loop += 1;
    }
    return nextDay;
  }

  businessAdd(incomingDay, number, period = 'days') {
    let _number = number;
    const day = incomingDay.clone();
    if (!day.isValid()) {
      return day;
    }
    if (_number < 0) {
      _number = Math.round(-1 * _number) * -1;
    } else {
      _number = Math.round(_number);
    }
    const signal = _number < 0 ? -1 : 1;
    let remaining = Math.abs(_number);
    while (remaining > 0) {
      day.add(signal, period);
      if (this.isBusinessDay(day)) {
        remaining -= 1;
      }
    }
    return day;
  }
}
module.exports = MomentBusinessDays;
